import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useTRPC } from '@/trpc/utils';

type ReturnFunction = (
  original: React.ReactElement | null,
  change: React.ReactElement | null,
) => React.ReactElement | null;

export const useAutoChangeComponent = (targetDate: Date): ReturnFunction => {
  const trpc = useTRPC();
  const { data: nowDate, error } = useQuery(trpc.now.queryOptions());

  if (!nowDate || error) {
    return (original, _) => original;
  }

  return (original, change) => {
    if (nowDate > targetDate) {
      return change;
    } else {
      return original;
    }
  };
};
